import CustomImageComponent from '../custom/custom-image';
import { getLogoImageUrl } from '@/helpers/local-images-helper';

const PredictingManagerIcon = ({ iconWidth = 25, iconHeight = 25, size = 150 }) => {
    const USE_LOCAL_IMAGES = process.env.NEXT_PUBLIC_USE_LOCAL_IMAGES === 'true';

    // Usar helper local que decide entre local o CDN según la flag
    const logoUrl = getLogoImageUrl('PREDICTING_MANAGER');

    // Si es local, no agregar parámetros de tamaño
    const src = USE_LOCAL_IMAGES && logoUrl
        ? logoUrl
        : `${process.env.NEXT_PUBLIC_IMAGES}/logos/predictingmanagers.png?width=${size ?? iconWidth}&height=${size ?? iconHeight}`;

    return (
        <CustomImageComponent
            src={src}
            alt="Predicting Manager"
            width={iconWidth}
            height={iconHeight}
        />
    );
};

export default PredictingManagerIcon;
